var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Layout',[_c('div',{staticClass:"container mt-4 mb-4 pl-1 pr-1"},[_c('ItemDocumento',{attrs:{"id":_vm.$route.params.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }